import {
    BASE_IMAGE_EXTENSIONS,
    IMAGE_UPLOAD_MAX_SIZE_MB,
} from '@modules/file/config/image-upload';

// global config
export const MAX_UPLOAD_FILE_NUMBER = 12;

// upload images
export const MAX_UPLOAD_IMAGE_SIZE = IMAGE_UPLOAD_MAX_SIZE_MB / 2; // 10MB
export const MIN_UPLOAD_IMAGE_WIDTH = 300;
export const MIN_UPLOAD_IMAGE_HEIGHT = 300;
export const ALLOWED_IMAGE_TYPES = [...BASE_IMAGE_EXTENSIONS];

// upload files
export const MAX_UPLOAD_FILE_SIZE = 120; // 120MB
export const ALLOWED_FILE_TYPES = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'csv',
    'webm',
    'mp4',
];
